/**
 * author: Soumya Shreyas
 */
 import React, { useEffect } from "react";
 import { Form, Pagination } from "react-bootstrap";
 import PropTypes from "prop-types";
 import { ITEMS_COUNT_PAGINATION_OPTION } from "../../core/constants/common"
 
 const PaginationBox = ({
   itemsTotalCount,
   itemsPerPage,
   currentPage,
   setCurrentPage,
   setItemsPerPage,
   alwaysShown = true,
   pageClicked,
 }) => {
   const pagesCount = Math.ceil(itemsTotalCount / itemsPerPage);
   const isPaginationShown = alwaysShown ? true : pagesCount > 1;
   const isCurrentPageFirst = currentPage === 1;
   const isCurrentPageLast = currentPage === pagesCount;
   var start = parseInt((currentPage - 1) * itemsPerPage + 1);
   var end = itemsPerPage * currentPage;
   if (itemsPerPage < itemsTotalCount) {
     end = itemsPerPage * currentPage
     if (end > itemsTotalCount) {
       end = itemsTotalCount;
     } 
   } else 
   {
     end = itemsTotalCount;
   }
 
   const changePage = (number) => {
     if (currentPage === number) return;
     setCurrentPage(number);
     pageClicked(number);
   };
 
   const onFirstPageClick = () => {
     changePage(1);
   };
 
   const onLastPageClick = () => {
     changePage(pagesCount);
   };
 
   const onPageNumberClick = (pageNumber) => {
     changePage(pageNumber);
   };
 
   const onPreviousPageClick = () => {
     changePage((currentPage) => currentPage - 1);
   };
 
   const onNextPageClick = () => {
     changePage((currentPage) => currentPage + 1);
   };
 
   const setLastPageAsCurrent = () => {
     if (currentPage > pagesCount) {
       setCurrentPage(pagesCount);
     }
   };
   const onItemsPerPageChange = (event) => {
     const { value } = event.target;
     const perPageCount = Number(value);
     setItemsPerPage(perPageCount);
     pageClicked(0, perPageCount);
   };
   let isPageNumberOutOfRange;
 
   const pageNumbers = [...new Array(pagesCount)].map((_, index) => {
     const pageNumber = index + 1;
     const isPageNumberFirst = pageNumber === 1;
     const isPageNumberLast = pageNumber === pagesCount;
     const isCurrentPageWithinTwoPageNumbers =
       Math.abs(pageNumber - currentPage) <= 2;
 
     if (
       isPageNumberFirst ||
       isPageNumberLast ||
       isCurrentPageWithinTwoPageNumbers
     ) {
       isPageNumberOutOfRange = false;
       return (
         <Pagination.Item
           key={pageNumber}
           onClick={() => onPageNumberClick(pageNumber)}
           active={pageNumber === currentPage}
         >
           {pageNumber}
         </Pagination.Item>
       );
     }
 
     if (!isPageNumberOutOfRange) {
       isPageNumberOutOfRange = true;
       return <Pagination.Ellipsis key={pageNumber} className="muted" />;
     }
 
     return null;
   });
 
   useEffect(setLastPageAsCurrent, [pagesCount]);
 
   return (
     <>
     <Form>
      <div className="Item_per_pageBox">
         {/* Items per page */}
         <select value={itemsPerPage} onChange={onItemsPerPageChange}>
           {ITEMS_COUNT_PAGINATION_OPTION.map(({ value, label }) => (
             <option key={value} value={value}>
               {label}
             </option>
           ))}
         </select>
       </div>
       </Form>
       <div className="Count_pages01">{start} - {end} of {itemsTotalCount}</div>
       {isPaginationShown && (
         <Pagination>
           <Pagination.First onClick={onFirstPageClick} />
           <Pagination.Prev
             onClick={onPreviousPageClick}
             disabled={isCurrentPageFirst}
           />
           {pageNumbers}
           <Pagination.Next
             onClick={onNextPageClick}
             disabled={isCurrentPageLast}
           />
           <Pagination.Last onClick={onLastPageClick} />
         </Pagination>
       )}
     </>
   );
 };
 
 PaginationBox.propTypes = {
   itemsTotalCount: PropTypes.number.isRequired,
   currentPage: PropTypes.number.isRequired,
   setCurrentPage: PropTypes.func.isRequired,
   setItemsPerPage: PropTypes.func.isRequired,
   alwaysShown: PropTypes.bool,
   pageClicked: PropTypes.func.isRequired
 };
export default PaginationBox;